/* ============
 * The initial state of the patient module.
 * ============
 */
export default {
  loading: false,
  patientProgressList: [],
  patientProgressDetails: {
    patientProgress: [{}],
    weeklyInterventions: [],
    assessmentAlerts: [],
    cycleInterventions: []
  },
  error: null,
  totalCount: 0,
  isPatientProgressloading: false,
  isPatientProgressListloading: false
};
